<template>
  <a-modal
    :title="$t('userCenter.changeAvatar')"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="800"
    :footer="null"
    @cancel="cancelHandel"
  >
    <a-row>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          outputType="png"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          @realTime="realTime"
        >
        </vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <div class="avatar-upload-preview">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :lg="2" :md="2">
        <a-upload
          name="file"
          accept="image/jpeg,image/jpg,image/png,image/bmp"
          :beforeUpload="beforeUpload"
          :showUploadList="false"
        >
          <a-button icon="upload">{{
            $t('userCenter.chooseImageBtn')
          }}</a-button>
        </a-upload>
      </a-col>
      <a-col :lg="{ span: 1, offset: 2 }" :md="2">
        <a-button icon="plus" @click="changeScale(1)" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="minus" @click="changeScale(-1)" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="undo" @click="rotateLeft" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="redo" @click="rotateRight" />
      </a-col>
      <a-col :lg="{ span: 2, offset: 6 }" :md="2">
        <a-button type="primary" @click="finish()">{{
          $t('userCenter.saveBtn')
        }}</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import { uploadBase64Img } from '@/api/fileUpload'
import { compressImageFile } from '../../utils/utils'

export default {
  data() {
    return {
      visible: false,
      id: null,
      confirmLoading: false,
      fileList: [],
      uploading: false,
      options: {
        img: '',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      },
      previews: {}
    }
  },
  methods: {
    edit(id) {
      this.visible = true
      this.id = id
      /* 获取原始头像 */
    },
    close() {
      this.id = null
      this.visible = false
    },
    cancelHandel() {
      this.close()
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    beforeUpload(file) {
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.options.img = reader.result
      }
      // 转化为blob
      // reader.readAsArrayBuffer(file)
      return false
    },

    // 上传图片（点击上传按钮）
    async finish() {
      this.$refs.cropper.getCropBlob(async data => {
        const file = new File([data], 'header', {
          type: data.type,
          lastModified: Date.now()
        })
        compressImageFile(file, { maxSize: 200 }, this.handleUploadBannerImg)
      })
      // 二进制方式  blob
      // this.$refs.cropper.getCropBlob
      // base64 方式
      // this.$refs.cropper.getCropData
    },
    async handleUploadBannerImg(image) {
      try {
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const res = await uploadBase64Img({ data: base64Unhead, suffix: 'png' })
        this.$message.success(this.$t('userCenter.uploadSuccess'))

        this.$emit('ok', res.data.collection[0])
        this.visible = false
      } catch (error) {
        this.$message.error(this.$t('userCenter.uploadFail'))
      }
    },
    okHandel() {
      this.confirmLoading = true
      setTimeout(() => {
        this.confirmLoading = false
        this.close()
        this.$message.success(this.$t('userCenter.uploadSuccess'))
      }, 2000)
    },

    realTime(data) {
      this.previews = data
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-preview {
  position: absolute;
  top: 50%;
  // transform: translate(100%, -50%);
  // width: 128px;
  // height: 128px;
  transform: translate(50%, -50%);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
